import { useCallback, useEffect, useRef, useState } from "react";
import { useApi } from "@/lib/api";

export function useLiveLocation(bookingId) {
  const api = useApi();
  const [sharing, setSharing] = useState(false);
  const [last, setLast] = useState(null);
  const [error, setError] = useState("");
  const watchRef = useRef(null);
  const sendingRef = useRef(false);

  const stop = useCallback(() => {
    if (watchRef.current != null) navigator.geolocation.clearWatch(watchRef.current);
    watchRef.current = null;
    setSharing(false);
  }, []);
  useEffect(() => stop, [stop]);

  const send = async (pos) => {
    if (sendingRef.current) return;
    sendingRef.current = true;
    const { latitude, longitude, accuracy, heading, speed } = pos.coords;
    try {
      await api.post(`/trips/${bookingId}/location`, {
        lat: latitude, lng: longitude, accuracy: accuracy || 0,
        heading: heading ?? -1, speed: speed ?? -1,
      });
      setLast(new Date());
      setError("");
    } catch (e) {
      setError(e?.response?.data?.detail || "Couldn't update location");
    } finally {
      sendingRef.current = false;
    }
  };

  const onGeoError = (e) => {
    setError(e.code === 1 ? "Location permission was blocked. Allow it in your browser to share your trip location." : "Couldn't get your location.");
    stop();
  };

  const start = () => {
    if (!navigator.geolocation) return setError("Location is not supported on this device.");
    setError("");
    setSharing(true);
    watchRef.current = navigator.geolocation.watchPosition(send, onGeoError, { enableHighAccuracy: true, maximumAge: 0, timeout: 20000 });
  };

  return { sharing, last, error, start, stop };
}
